// extracted by mini-css-extract-plugin
module.exports = {"custom-500":"FailurePage_custom-500__rznKU"};